import { Field, FieldProps } from 'formik';
import React from 'react';
import { EnumDamWallType } from '../../../../@types/model/dam/dam';
import DamWallTypeSelector, { IDamWallTypeSelectorProps } from '../../selector/dam/DamWallTypeSelector';

type DamWallTypeFormFieldPropsType = FieldProps<EnumDamWallType | null> & Omit<IDamWallTypeSelectorProps, 'value' | 'onChange'>;

interface IDamWallTypeFormFieldProps extends DamWallTypeFormFieldPropsType {
    name : string;
}

class DamWallTypeFormFieldComponent extends React.PureComponent<IDamWallTypeFormFieldProps> {
    constructor(props : IDamWallTypeFormFieldProps) {
        super(props);
    }

    private readonly onDamWallTypeChange = (value : EnumDamWallType | null) => {
        const { field, form } = this.props;

        form.setFieldValue(field.name, value);
    };

    public readonly render = () => {
        const { field, form: _form, meta: _meta, name: _name, ...rest } = this.props;
        return (
            <DamWallTypeSelector
                {...rest}
                value={field.value} 
                onChange={this.onDamWallTypeChange}                                        
            />
        );
    };
}

export default class DamWallTypeFormField extends React.PureComponent<{name : string; label : string}> {
    constructor(props : {name : string; label : string}) {
        super(props);
    }

    public render = () => {
        const { name, label } = this.props;
        return (
            <Field
                name={name}
                label={label}
                component={DamWallTypeFormFieldComponent}                                  
            >
            </Field>
        );
    };
}
